<div  (drop)="onDrop($event)" (dragover)="onDragOver($event)"
(dragenter)="onDragEnter($event)" (dragleave)="onDragLeave($event)"
 (paste)="onPaste($event)" [ngClass]="{'fileover' : fileOver, 'support-container': isSupport}" class="particle-task-container">
  <!--toolbar-->
  <particle-task-toolbar
    *ngIf="isReady"
    id="task-toolbar"
    [data]="data"
    [isSupportMember]="isSupportMember"
    (actionEvent$)="handleActionEvent($event)"></particle-task-toolbar>

  <!--taskbody-->
  <particle-task-body
    *ngIf="isReady"
    id="task-body"
    [data]="data"
    [defaultMainViewDetails]="defaultMainViewDetails"
    [selectedMainViewDetails$]="selectedMainViewDetails$"
    [taskMenuItemsMapper]="taskMenuItemsMapper"
    (actionEvent$)="handleActionEvent($event)"></particle-task-body>

  <!--task rightbar-->
  <particle-task-view-right-bar
    *ngIf="isReady"
    id="task-view-right-bar"
    [data]="data"
    [taskMenuItemsMapper]="taskMenuItemsMapper"
    (selectedMenuChange$)="setMainViewDetails($event)"></particle-task-view-right-bar>
</div>
